module.exports = __webpack_public_path__ + "img/icon_train.a01bd223.svg";